import React, { useEffect, useState } from 'react';

import { headers, valoresExibidos } from './auxiliarPlanoTrabalho';
import BarraInferiorBotoes from '../../../../../components/BarraInferiorBotoes';
import BoxConteudo from '../../../../../components/BoxConteudo';
import CustomButton from '../../../../../components/CustomButton';
import CustomCol from '../../../../../components/CustomCol';
import CustomOffcanvas from '../../../../../components/CustomOffcanvas';
import CustomRow from '../../../../../components/CustomRow';
import Input from '../../../../../components/InputNew';
import Select from '../../../../../components/InputNew/Select';
import Checkbox from '../../../../../components/Inputs/Checkbox';
import Log from '../../../../../components/Log/Log';
import Tabela from '../../../../../components/Tabela';
import WorkspaceBotoes from '../../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../../components/WorkspaceFicha';
import { getPlanosTrabalhoPorAct } from '../../../../../services/acts/actsPlanoTrabalhoService';
import httpClient, { isHttpError } from '../../../../../services/httpClient';
import { getProdutosByUsuario } from '../../../../../services/produtosDAF/produtosDafService';
import theme from '../../../../../theme';
import {
  formataNomeMeioSiglas,
  formatarNumero,
  formatarValorFormatoDinheiro,
  formatDate,
  formatDateSimp,
  formatoMoney,
  formatValorDinheiro,
} from '../../../../../utils/functions';
import {
  swalAttention,
  swalAtualizacao,
  swalDelete,
  swalDeleteConfirm,
  swalErro,
  swalSave,
} from '../../../../../utils/swal';

interface Props {
  novoRegistro: boolean;
  componente: number;
  idAct: number;
  actLabel: string;
}

type FormType = {
  id: number;
  actId: number;
  produtoDafId: number;
  numeroItem: number;
  embalagemFator: string;
  qtdAdministrativa: string;
  qtdEstrategico: string;
  qtdJudicial: string;
  qtdOutro: string;
  qtdTotal: string;
  embalagemTotal: string;
  dataPrevista: string;

  valorUnitHomologado: string;
  valorReequilibrioBin: boolean;
  valorUnitReequilibrio: string | null;
  valorTotal: string;

  observacoes: string;
};

export const ActPlanoTrabalho: React.FC<Props> = ({
  novoRegistro,
  componente,
  idAct,
  actLabel,
}) => {
  //////STATES
  const [showModal, setShowModal] = useState(false);
  const [logData, setLogData] = useState<any>();
  const [recordId, setRecordId] = useState('');
  const [updating, setUpdating] = useState(false);
  const [form, setForm] = useState<FormType>({
    id: 0,
    actId: idAct,
    produtoDafId: 0,
    numeroItem: 0,
    embalagemFator: '',
    qtdAdministrativa: '',
    qtdEstrategico: '',
    qtdJudicial: '',
    qtdOutro: '',
    qtdTotal: '',
    embalagemTotal: '',
    dataPrevista: '',

    valorUnitHomologado: '',
    valorReequilibrioBin: false,
    valorUnitReequilibrio: null as string | null,
    valorTotal: '',

    observacoes: '',
  });

  //////FETCH DATA
  const [data, setData] = useState<any[]>([]);
  const fetchMain = async () => {
    try {
      const registros = await getPlanosTrabalhoPorAct(String(idAct));

      setForm((prev) => ({
        ...prev,
        actId: idAct,
      }));

      // Junta tudo em um único array
      setData(registros);
    } catch (error) {
      console.error('Erro ao obter dados', error);
    }
  };
  const [produtoData, setProdutoData] = useState<
    { value: number; label: string }[]
  >([]);
  const fetchProdutos = async () => {
    try {
      const produtos = await getProdutosByUsuario();
      setProdutoData([
        { value: 0, label: 'Não informado' },
        ...produtos.map(
          (item: { id: number; produtoFarmaceutico: string }) => ({
            value: item.id,
            label: item.produtoFarmaceutico,
          }),
        ),
      ]);
    } catch (error) {
      console.error('Erro ao obter produtos:', error);
      setProdutoData([]);
    }
  };
  useEffect(() => {
    fetchMain();
    fetchProdutos();
  }, []);

  //////TABLE E OFFCANVAS
  const tableDataPlanoTrabalho =
    data
      ?.slice() // faz uma cópia para não mutar o array original
      .sort((a, b) => Number(a.numeroItem) - Number(b.numeroItem))
      .map((item) => {
        return {
          id: item.id,
          numeroItem: item.numeroItem,
          // numeroPa: item.tedPlanoAcao.numeroPa,
          dataPrevista: item.dataPrevista
            ? formatDateSimp(item.dataPrevista)
            : '',
          produtoDaf: item.produtoDAF.produtoFarmaceutico,
          qtdTotal: (
            <div style={{ textAlign: 'right' }}>
              {formatarNumero(item.qtdTotal)}
            </div>
          ),
          valorTotal: (
            <div style={{ textAlign: 'right' }}>
              {formatarValorFormatoDinheiro(item.valorTotal)}
            </div>
          ),
        };
      }) || [];

  const offCanvasData =
    data?.map((item) => {
      return {
        id: item.id,
        dataRegistro:
          formatDate(item.dataRegistro) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
        dataUltimaAtualizacao:
          formatDate(item.dataUltimaAtualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),
        dataUltimaVisualizacao:
          formatDate(item.dataUltimaVisualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        separadorLog: '',
        actId: item.act.id,
        actLabel: item.act.numeroAct,
        separador1: '',
        numeroItem: item.numeroItem,
        dataPrevista: formatDateSimp(item.dataPrevista),
        separador2: '',
        qtdAdministrativa: (
          <span
            style={{
              padding: '5px',
              minWidth: '100px',
              textAlign: 'right',
              width: '100%',
              display: 'block',
            }}
          >
            {formatarNumero(item.qtdAdministrativa)}
          </span>
        ),
        qtdEstrategico: (
          <span
            style={{
              padding: '5px',
              minWidth: '100px',
              textAlign: 'right',
              width: '100%',
              display: 'block',
            }}
          >
            {formatarNumero(item.qtdEstrategico)}
          </span>
        ),
        qtdJudicial: (
          <span
            style={{
              padding: '5px',
              minWidth: '100px',
              textAlign: 'right',
              width: '100%',
              display: 'block',
            }}
          >
            {formatarNumero(item.qtdJudicial)}
          </span>
        ),
        qtdOutro: (
          <span
            style={{
              padding: '5px',
              minWidth: '100px',
              textAlign: 'right',
              width: '100%',
              display: 'block',
            }}
          >
            {formatarNumero(item.qtdOutro)}
          </span>
        ),
        qtdTotal: (
          <span
            style={{
              padding: '5px',
              minWidth: '100px',
              textAlign: 'right',
              width: '100%',
              display: 'block',
            }}
          >
            {formatarNumero(item.qtdTotal)}
          </span>
        ),
        separador3: '',
        embalagemFator: (
          <span
            style={{
              padding: '5px',
              minWidth: '100px',
              textAlign: 'right',
              width: '100%',
              display: 'block',
            }}
          >
            {formatarNumero(item.embalagemFator)}
          </span>
        ),
        embalagemTotal: (
          <span
            style={{
              padding: '5px',
              minWidth: '100px',
              textAlign: 'right',
              width: '100%',
              display: 'block',
            }}
          >
            {formatarNumero(item.embalagemTotal)}
          </span>
        ),
        separador4: '',
        valorUnitHomologado: (
          <span
            style={{
              padding: '5px',
              minWidth: '100px',
              textAlign: 'right',
              width: '100%',
              display: 'block',
            }}
          >
            {formatarValorFormatoDinheiro(item.valorUnitHomologado)}
          </span>
        ),
        valorReequilibrioBin: (
          <span
            style={{
              padding: '5px',
              minWidth: '100px',
              textAlign: 'right',
              width: '100%',
              display: 'block',
            }}
          >
            {item.valorReequilibrioBin === true ? 'Sim' : 'Não'}
          </span>
        ),
        valorUnitReequilibrio: (
          <span
            style={{
              padding: '5px',
              minWidth: '100px',
              textAlign: 'right',
              width: '100%',
              display: 'block',
            }}
          >
            {item.valorReequilibrioBin === true
              ? formatarValorFormatoDinheiro(item.valorUnitReequilibrio)
              : '-'}
          </span>
        ),
        valorTotal: (
          <span
            style={{
              padding: '5px',
              minWidth: '100px',
              textAlign: 'right',
              width: '100%',
              display: 'block',
            }}
          >
            {formatarValorFormatoDinheiro(item.valorTotal)}
          </span>
        ),
        separador5: '',
        observacoes: item.observacoes,
      };
    }) || [];

  //////FUNÇÕES HANDLE
  const handleClearForm = () => {
    setForm({
      id: 0,
      actId: 0,
      produtoDafId: 0,
      numeroItem: 0,

      embalagemFator: '',
      qtdAdministrativa: '',
      qtdEstrategico: '',
      qtdJudicial: '',
      qtdOutro: '',
      qtdTotal: '',
      embalagemTotal: '',

      dataPrevista: '',

      valorUnitHomologado: '',
      valorReequilibrioBin: false,
      valorUnitReequilibrio: '',
      valorTotal: '',

      observacoes: '',
    });
    setLogData({
      id: 0,
      usuarioRegistro: '',
      usuarioAtualizacao: '',
      dataRegistro: '',
      dataAtualizacao: '',
      nEdicoes: 0,
    });
  };

  const handleShowModal = () => setShowModal((prev) => !prev);

  const handleClickInserirNovo = () => {
    handleClearForm();
    setUpdating(false);
    handleShowModal();
  };

  const handleRowClick = (id: string) => {
    setRecordId(id);
    setUpdating(true);
    setShowModal(true);
    const itemSelecionado = data?.find((d) => d.id === id);

    if (itemSelecionado) {
      const formatDateLocal = (iso: string) => iso?.split('T')[0];
      setForm({
        id: Number(itemSelecionado.id),
        actId: Number(itemSelecionado.act.id),
        produtoDafId: Number(itemSelecionado.produtoDAF.id),
        numeroItem: itemSelecionado.numeroItem,
        embalagemFator: formatarNumero(itemSelecionado.embalagemFator),
        qtdAdministrativa: formatarNumero(itemSelecionado.qtdAdministrativa),
        qtdEstrategico: formatarNumero(itemSelecionado.qtdEstrategico),
        qtdJudicial: formatarNumero(itemSelecionado.qtdJudicial),
        qtdOutro: formatarNumero(itemSelecionado.qtdOutro),
        qtdTotal: '',
        embalagemTotal: '',
        dataPrevista: itemSelecionado.dataPrevista
          ? formatDateLocal(itemSelecionado.dataPrevista)
          : '',
        valorUnitHomologado: formatarValorFormatoDinheiro(
          itemSelecionado.valorUnitHomologado,
        ),
        valorReequilibrioBin:
          itemSelecionado.valorReequilibrioBin == 'S' ? true : false,
        valorUnitReequilibrio: formatarValorFormatoDinheiro(
          itemSelecionado.valorUnitReequilibrio,
        ),
        valorTotal: formatoMoney(
          Number(itemSelecionado.valorTotal ?? 0).toFixed(2),
        ),

        observacoes: itemSelecionado.observacoes,
      });

      setLogData({
        id: itemSelecionado.id,
        usuarioRegistro: itemSelecionado.usuarioRegistro?.nomeCompleto || '',
        usuarioAtualizacao:
          itemSelecionado.usuarioAtualizacao?.nomeCompleto || '',
        dataRegistro: itemSelecionado.dataRegistro,
        dataAtualizacao: itemSelecionado.dataUltimaAtualizacao,
        nEdicoes: itemSelecionado.nEdicoes,
      });
    }

    setTimeout(() => {
      handleChange({
        target: {
          name: 'qtdAdministrativa',
          type: 'text',
          value: itemSelecionado.qtdAdministrativa?.toString() ?? '0',
        },
      } as React.ChangeEvent<HTMLInputElement>);
    }, 0);
  };

  //////FUNÇÕES CRUD
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, type, value, checked } = event.target as HTMLInputElement;

    setForm((prev) => {
      const newValue =
        type === 'checkbox'
          ? checked
          : name.startsWith('valor')
            ? formatoMoney(value)
            : name === 'embalagemFator' || name.startsWith('qtd')
              ? formatarNumero(value)
              : value;

      const camposQtd = [
        'qtdAdministrativa',
        'qtdEstrategico',
        'qtdJudicial',
        'qtdOutro',
      ];

      const novasQuantidades = {
        ...prev,
        [name]: newValue,
      };

      // Recalcular qtdTotal
      let qtdTotal = prev.qtdTotal;
      if (camposQtd.includes(name)) {
        const soma = camposQtd
          .map((campo) =>
            Number(
              String((novasQuantidades as any)[campo] ?? '0').replace(
                /\./g,
                '',
              ),
            ),
          )
          .reduce((acc, val) => acc + val, 0);

        qtdTotal = formatarNumero(soma.toString());
        novasQuantidades.qtdTotal = qtdTotal;
      }

      // Recalcular valores
      const qtdTotalNumber = Number(
        (novasQuantidades.qtdTotal || '0').replace(/\./g, ''),
      );
      const valorUnitHomologadoNumber = Number(
        (novasQuantidades.valorUnitHomologado || '0')
          .replace(/\./g, '')
          .replace(',', '.'),
      );
      const valorUnitReequilibrioNumber = Number(
        (novasQuantidades.valorUnitReequilibrio || '0')
          .replace(/\./g, '')
          .replace(',', '.'),
      );

      const valorTotalCalculado = novasQuantidades.valorReequilibrioBin
        ? qtdTotalNumber * valorUnitReequilibrioNumber
        : qtdTotalNumber * valorUnitHomologadoNumber;

      // Recalcular embalagemTotal
      const embalagemFatorNumber = Number(
        (novasQuantidades.embalagemFator || '0').replace(/\./g, ''),
      );

      let embalagemTotal = '0';
      if (embalagemFatorNumber > 0) {
        const total = qtdTotalNumber / embalagemFatorNumber;
        embalagemTotal = formatarNumero(Math.floor(total).toString());
      }

      return {
        ...novasQuantidades,
        qtdTotal,
        valorTotal: formatoMoney(valorTotalCalculado.toFixed(2)),
        embalagemTotal,
      };
    });
  };

  const handleCreate = async () => {
    try {
      if (!validateForm(form)) throw new Error('Formulário inválido.');

      const adjustedForm = adjustFormBeforeSubmit(form);

      await httpClient.post(`/api/act-plano-trabalho`, adjustedForm);

      swalSave();
      fetchMain();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao salvar registro:', err);
    }
  };

  const handleUpdate = async () => {
    try {
      if (!validateForm(form)) throw new Error('Formulário inválido.');

      const adjustedForm = adjustFormBeforeSubmit(form);

      const response = await httpClient.patch(
        `/api/act-plano-trabalho/${recordId}`,
        adjustedForm,
      );

      swalAtualizacao('Sucesso', response.data.message);
      fetchMain();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao atualizar registro:', err);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();
    if (!result) return swalErro('A operação falhou.');
    try {
      await httpClient.delete(`/api/act-plano-trabalho/${recordId}`);
      swalDeleteConfirm();
      fetchMain();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao excluir registro:', err);
    }
  };

  //////OUTRAS FUNÇÕES
  const validateForm = (form: any) => {
    const errors = [];

    if (form.produtoDafId === 0) {
      errors.push('<b>Produto Farmacêutico</b> é obrigatório.');
    }

    if (form.embalagemFator === '') {
      errors.push('<b>Qtd ADMINISTRATIVA</b> é obrigatório.');
    }

    if (form.qtdAdministrativa === '') {
      errors.push('<b>Qtd ADMINISTRATIVA</b> é obrigatório.');
    }

    if (form.qtdEstrategico === '') {
      errors.push('<b>Qtd ESTRATEGICO</b> é obrigatório.');
    }

    if (form.qtdJudicial === '') {
      errors.push('<b>Qtd JUDICIAL</b> é obrigatório.');
    }

    if (form.qtdOutro === '') {
      errors.push('<b>Qtd OUTRO</b> é obrigatório.');
    }

    if (form.valorUnitHomologado === '') {
      errors.push('<b>Valor Unitário Homologado</b> é obrigatório.');
    }

    if (form.dataPrevista === '') {
      errors.push('<b>Data Prevista</b> é obrigatório.');
    }

    if (errors.length > 0) {
      swalAttention(errors.join('<br>'));
      return false;
    }
    return true;
  };

  const adjustFormBeforeSubmit = (form: any) => {
    const adjustedForm = {
      ...form,
      actId: Number(idAct),
      produtoDafId: Number(form.produtoDafId),
      numeroItem: Number(form.numeroItem),
      embalagemFator: Number(form.embalagemFator.replace(/\./g, '')),
      qtdAdministrativa: Number(form.qtdAdministrativa.replace(/\./g, '')),
      qtdEstrategico: Number(form.qtdEstrategico.replace(/\./g, '')),
      qtdJudicial: Number(form.qtdJudicial.replace(/\./g, '')),
      qtdOutro: Number(form.qtdOutro.replace(/\./g, '')),
      valorUnitHomologado: Number(
        form.valorUnitHomologado.replace(/\./g, '').replace(',', '.'),
      ),
      valorUnitReequilibrio: form?.valorReequilibrioBin
        ? Number(
            form.valorUnitReequilibrio.replace(/\./g, '').replace(',', '.'),
          )
        : null,
      valorReequilibrioBin: form?.valorReequilibrioBin ? 'S' : 'N',

      //Observações
      observacoes:
        form.observacoes === ''
          ? 'Sem observações específicas.'
          : form.observacoes,
    };

    // Remover campos não desejados
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { embalagemTotal, qtdTotal, valorTotal, ...cleanForm } = adjustedForm;
    return cleanForm;
  };

  const [
    isValorUnitarioHomologadoReadOnly,
    setIsValorUnitarioHomologadoReadOnly,
  ] = useState(false);
  useEffect(() => {
    if (form.valorReequilibrioBin === false) {
      setIsValorUnitarioHomologadoReadOnly(true);
      setForm((prev) => ({
        ...prev,
        valorUnitReequilibrio: null,
      }));
    } else {
      setIsValorUnitarioHomologadoReadOnly(false);
    }
  }, [form.valorReequilibrioBin]);

  return (
    <BoxConteudo boxTitulo="Plano de Trabalho">
      <CustomRow>
        <CustomCol width="100%">
          <Tabela
            headers={headers}
            dataTable={tableDataPlanoTrabalho}
            displayValues={valoresExibidos}
            onRowClick={handleRowClick}
            dataOffCanvas={offCanvasData}
            botaoAbrirOffCanvas={false}
            showPagination={false}
            mostrarBotaoCopiar={false}
          />
        </CustomCol>
      </CustomRow>
      <CustomCol className="d-flex justify-content-end">
        <CustomButton
          label="Novo Registro"
          bgColor={theme.colors.botaoAcao.azul}
          textColor={theme.colors.white}
          onClick={() => {
            setUpdating(false);
            handleClickInserirNovo();
          }}
          disabled={!novoRegistro}
        />
      </CustomCol>

      {/* Modal/*/}
      <CustomOffcanvas
        title="Plano de Trabalho"
        show={showModal}
        onClose={handleShowModal}
        width="70vw"
      >
        <WorkspaceFicha>
          <Log
            {...logData}
            entity="TB_ACT_PLANO_TRABALHO"
            id={Number(form.id)}
          />

          <BoxConteudo boxTitulo="Identificação do Item">
            {/* Plano de Trabalho */}
            <CustomRow style={{ marginTop: '10px' }}>
              <CustomCol width="150px">
                <Input
                  id="actId"
                  name="actId"
                  value={form.actId === 0 ? idAct : form.actId}
                  label="ID ACT"
                  // eslint-disable-next-line @typescript-eslint/no-empty-function
                  onChange={() => {}}
                  readonly
                />
              </CustomCol>
              <CustomCol width="300px">
                <Input
                  id="actId"
                  name="actId"
                  value={actLabel}
                  label="ACT"
                  // eslint-disable-next-line @typescript-eslint/no-empty-function
                  onChange={() => {}}
                  readonly
                />
              </CustomCol>
              <CustomCol width="150px">
                <Input
                  id="numeroItem"
                  name="numeroItem"
                  value={form.numeroItem}
                  label="Nº Item"
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol></CustomCol>
            </CustomRow>

            {/* Produto DAF */}
            <CustomRow>
              <CustomCol width="150px">
                <Input
                  id="produtoDafId"
                  name="produtoDafId"
                  value={form.produtoDafId === 0 ? '' : form.produtoDafId}
                  label="ID Produto"
                  // eslint-disable-next-line @typescript-eslint/no-empty-function
                  onChange={() => {}}
                  readonly
                />
              </CustomCol>
              <CustomCol>
                <Select
                  name="produtoDafId"
                  value={form.produtoDafId}
                  label="Produto Farmacêutico"
                  options={produtoData}
                  onChange={handleChange}
                  required
                  disabled={updating}
                />
              </CustomCol>
            </CustomRow>

            {/* Quantidade e Valores da ARP */}
            <CustomRow>
              <CustomCol width="200px">
                <Input
                  name="embalagemFator"
                  label="Fator Embalagem"
                  value={form.embalagemFator}
                  id="embalagemFator"
                  onChange={handleChange}
                  textAlign="right"
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="qtdAdministrativa"
                  label="Qtd Administrativa"
                  value={form.qtdAdministrativa}
                  id="qtdAdministrativa"
                  onChange={handleChange}
                  textAlign="right"
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="qtdEstrategico"
                  label="Qtd Estratégico"
                  value={form.qtdEstrategico}
                  id="qtdEstrategico"
                  onChange={handleChange}
                  textAlign="right"
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="qtdJudicial"
                  label="Qtd Judicial"
                  value={form.qtdJudicial}
                  id="qtdJudicial"
                  onChange={handleChange}
                  textAlign="right"
                  required
                />
              </CustomCol>
              <CustomCol width="180px">
                <Input
                  name="qtdOutro"
                  label="Qtd Outro"
                  value={form.qtdOutro}
                  id="qtdOutro"
                  onChange={handleChange}
                  textAlign="right"
                  required
                />
              </CustomCol>
              <CustomCol>
                <Input
                  name="qtdTotal"
                  label="Qtd Total"
                  value={form.qtdTotal}
                  id="qtdTotal"
                  onChange={handleChange}
                  textAlign="right"
                  readonly
                />
              </CustomCol>
              <CustomCol width="150px">
                <Input
                  name="embalagemTotal"
                  label="Total Embalagens"
                  value={form.embalagemTotal}
                  id="embalagemTotal"
                  onChange={handleChange}
                  textAlign="right"
                  readonly
                />
              </CustomCol>
            </CustomRow>

            {/* Valores */}
            <CustomRow>
              <CustomCol width="200px">
                <Input
                  id="dataPrevista"
                  name="dataPrevista"
                  label="Data de Entrega Prevista"
                  value={form.dataPrevista}
                  onChange={handleChange}
                  type="date"
                  required
                />
              </CustomCol>

              <CustomCol width="200px">
                <Input
                  name="valorUnitHomologado"
                  label="Valor Unitário Homologado"
                  value={form.valorUnitHomologado}
                  id="valorUnitHomologado"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  required
                />
              </CustomCol>
              <CustomCol width="250px">
                <div
                  style={{
                    marginBottom: '5px',
                    paddingTop: '0px',
                    color: theme.colors.botaoConfirmar,
                  }}
                >
                  Valor Unitário Reequilíbrio
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '2px',
                  }}
                >
                  <Checkbox
                    name="valorReequilibrioBin"
                    label=""
                    checked={form.valorReequilibrioBin}
                    style={{ fontSize: '1.5rem' }}
                    onChange={handleChange}
                  ></Checkbox>
                  <Input
                    name="valorUnitReequilibrio"
                    label=""
                    value={
                      form.valorReequilibrioBin
                        ? form.valorUnitReequilibrio
                          ? formatValorDinheiro(form.valorUnitReequilibrio)
                          : ''
                        : ''
                    }
                    id="valorUnitReequilibrio"
                    onChange={handleChange}
                    readonly={isValorUnitarioHomologadoReadOnly}
                    style={{ textAlign: 'right' }}
                  />
                </div>
              </CustomCol>
              <CustomCol width="250px">
                <Input
                  name="valorTotal"
                  label="Valor Total R$"
                  value={form.valorTotal}
                  id="valorTotal"
                  onChange={handleChange}
                  textAlign="right"
                  readonly
                />
              </CustomCol>
              <CustomCol></CustomCol>
            </CustomRow>

            {/* Observações */}
            <CustomRow>
              <CustomCol width="100%">
                <Input
                  id="observacoes"
                  name="observacoes"
                  value={form.observacoes}
                  label="Observações"
                  type="textarea"
                  onChange={handleChange}
                  linhas={3}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          <BarraInferiorBotoes>
            {updating ? (
              <WorkspaceBotoes
                delete
                // deleteDisabled={btDisable}
                onClickDelete={handleDelete}
                save
                // saveDisabled={btDisable}
                onClickSave={handleUpdate}
              />
            ) : (
              <WorkspaceBotoes
                inserir
                // inserirDisabled={btDisable}
                onClickInserir={handleCreate}
              />
            )}
          </BarraInferiorBotoes>
        </WorkspaceFicha>
      </CustomOffcanvas>
    </BoxConteudo>
  );
};
